import React from "react";
import { Facebook, Instagram, YouTube, LocationOn, Phone, Email } from "@mui/icons-material";
import { Logo } from "../../assets/img";

const Footer = () => {
  return (
    <footer className="footer-ticket">

      {/* Scratch gold shine line */}
      <div className="gold-shine"></div>

      <div className="footer-wrapper">

        {/* LOGO */}
        <div className="footer-left">
          <div className="ticket-logo-box">
            <img src={Logo} className="ticket-logo" alt="Company" />
          </div>
          <p className="ticket-tagline">India’s Safest Online Lottery Platform</p>
        </div>

        {/* ADDRESS */}
        <div className="footer-middle">
          <h3 className="ticket-title">Contact Info</h3>

          <p><LocationOn /> Parassala, kerala – 695508</p>
          <p><Phone /> +91 9876543210</p>
          <p><Email /> support@Goldenlottery.in</p>
        </div>

        {/* SOCIAL */}
        <div className="footer-right">
          <h3 className="ticket-title">Follow Us</h3>
          <div className="ticket-social">
            <Facebook className="ticon" />
            <Instagram className="ticon" />
            <YouTube className="ticon" />
          </div>
        </div>

      </div>

      <p className="ticket-copy">© {new Date().getFullYear()} Lottery India — All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
